import { useQuery } from '@tanstack/react-query';
import type { InventoryKpiView } from '@/lib/api-admin/types';
import { apiClient } from '@/lib/apiClient';

export const inventoryKpiQueryKey = () => ['admin', 'inventory', 'kpi'] as const;

export const useInventoryKpiQuery = () =>
  useQuery<InventoryKpiView>({
    queryKey: inventoryKpiQueryKey(),
    queryFn: async () => {
      const [data] = await apiClient.request('get', '/admin/v1/inventory/kpi', {});
      return data as InventoryKpiView;
    },
  });
